import deviceInfo from './deviceInfo';

export const isFirefoxBrowser = /firefox/i.test(navigator.userAgent.toLocaleLowerCase());
export const isIosUnder13Version = (
  deviceInfo && deviceInfo?.os?.name.toLocaleLowerCase() === 'ios' && Number(deviceInfo?.os?.version) < 13
);
export const isSafariBrowser = deviceInfo?.client?.name.toLowerCase() === 'safari';
export const isIOS = deviceInfo?.os?.name.toLowerCase() === 'ios';
